import { CardContent, Grid } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { FormProvider } from 'react-hook-form'
import { CustomActionsButtons } from '../../../../components/CustomActionsButtons'
import { FormularioRegraTransformacaoApi } from '../../../../components/CustomFormControl/FormularioRegraTransformacaoApi/index'
import Modal from '../../../../components/Modal/Modal'
import { TRANSFORMACAO, TRANSFORMACAO_MODAL } from '../../../../constants/transformacao'
import { Container, Main, Subtitle } from './RegraTransformacaoApiForm.style'
import { regraTransformacaoApiFormIO } from './RegraTransformacaoApiForm.IO'
import { RegraTransformacao } from '../../../../types/transformacaoApiTypes'
import { Tipografia } from '../../../../components/Tipografia'

export type RegraTransformacaoApiFormProps = {
  regraTransformacaoEditar?: RegraTransformacao
}

export default function RegraTransformacaoFormApiView({ _io }: IOProps<regraTransformacaoApiFormIO, RegraTransformacaoApiFormProps>) {
  return (
    <>
      <Main>
        <Container>
          <CardContent>
            <Tipografia variant="h6">{_io.regraId ? TRANSFORMACAO.formularioTituloEditarRegra : TRANSFORMACAO.formularioTituloNovaRegra}</Tipografia>
            <Subtitle>{TRANSFORMACAO.formularioSubtitulo}</Subtitle>
            <FormProvider {..._io.parametrosForm}>
              <form onSubmit={_io.parametrosForm.handleSubmit(_io.enviarDadosFormulario)}>
                <FormularioRegraTransformacaoApi
                  isEdicao={_io.regraId ? true : false}
                  mudarStatusParaAtivo={_io.mudarStatusParaAtivo}
                  ativo={_io.switchAtivo}
                  condicaoLista={_io.condicaoList}
                  acaoLista={_io.acaoList}
                  grupoRegraLista={_io.grupoRegraList}
                  cabecalhosPlanilha={_io.fieldDado}
                />
                <CustomActionsButtons
                  hasCancel
                  hasSave
                  hasSaveContinue={!_io.regraId}
                  handleCancelar={_io.handleCancelar}
                  handleSave={() => _io.setSave(false)}
                  handleSaveContinue={() => _io.setSave(true)}
                />
              </form>
            </FormProvider>
          </CardContent>
        </Container>
        <Modal
          title={TRANSFORMACAO_MODAL.titulo}
          openModal={_io.openModal}
          fullWidth={false}
          maxWidth={false}
          onClose={_io.handleCloseModal}
          onAction={_io.handleCloseModal}
          hiddenButton
        >
          <Grid item sm={12}></Grid>
        </Modal>
      </Main>
    </>
  )
}
